import { AlignLeft, AlignCenter, AlignRight } from "lucide-react";

/**
 * AlignmentToggle — segmented control for choosing Left / Center / Right
 * alignment. Used in module instance editors to set per-element justification.
 */
export function AlignmentToggle({ label, value = "center", onChange, testId }) {
  const options = [
    { val: "left", Icon: AlignLeft, ariaLabel: "Left align" },
    { val: "center", Icon: AlignCenter, ariaLabel: "Center align" },
    { val: "right", Icon: AlignRight, ariaLabel: "Right align" },
  ];
  return (
    <div className="space-y-1">
      {label && <span className="text-xs font-medium block">{label}</span>}
      <div
        className="inline-flex rounded-md border border-input bg-background overflow-hidden"
        data-testid={testId}
      >
        {options.map(({ val, Icon, ariaLabel }) => {
          const active = (value || "center") === val;
          return (
            <button
              key={val}
              type="button"
              onClick={() => onChange(val)}
              aria-label={ariaLabel}
              aria-pressed={active}
              data-testid={testId ? `${testId}-${val}` : undefined}
              className={
                "px-3 py-1.5 inline-flex items-center justify-center transition-colors " +
                (active ? "bg-primary text-primary-foreground" : "hover:bg-muted text-foreground")
              }
            >
              <Icon className="h-4 w-4" />
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default AlignmentToggle;
